import _u from './util';
import _v from './vars';
import _f from './func';
import _t from './templates/cmeglider_t';
import _feedt from './templates/feed_t';

import _ from 'lodash';


let origX = 0;
let origY = 0;
let touchDebounce = null;
let slideContainer = null;
let gliderJson = null;
let ajaxDone = false;
let ajaxAndFeedDone = false;

function preventDef(e) {
    e.preventDefault();
}

/* Custom Swiping */

// Unbind all event listeners after swipe complete
function handleTouchEnd(e) {
    document.removeEventListener('touchmove', preventDef);
	slideContainer.removeEventListener('touchmove', handleTouchMove);
	slideContainer.removeEventListener('mousemove', handleTouchMove);
	slideContainer.removeEventListener('touchend', handleTouchEnd);
	slideContainer.removeEventListener('mouseup', handleTouchEnd);
}

function handleTouchMove(e) {
	e.preventDefault();
	e.stopPropagation();
	_v.cmeGliderSwiping = true; // Set flag in code that swipe currently happening
	 // Save new cursor position after swipe
	let currX = 0;
	if (e.type == 'touchmove') {
		currX = e.touches[0].pageX;		
	} else if  (e.type == 'mousemove') {
		currX = e.pageX;		
	}
	let currY = 0;
	if (e.type == 'touchmove') {
		currY = e.touches[0].pageY;		
	} else if  (e.type == 'mousemove') {
		currY = e.pageY;		
	}
	// If swipe is going horizontally and swiping finger to left
	if (currX - origX < 0 && Math.abs((currX - origX)) > Math.abs((currY - origY))) {
		document.addEventListener('touchmove', preventDef, { passive: false });
		slideContainer.scrollLeft -= (currX - origX);
		_v.cmeGliderInst.scrollItem(_v.cmeGliderInst.slide + 1); // Advance slide using GliderJS function + property
	}
	// If swipe is going horizontally and swiping finger to right
	else if  (currX - origX > 0 && Math.abs((currX - origX)) > Math.abs((currY - origY))) {
		document.addEventListener('touchmove', preventDef, { passive: false });
		slideContainer.scrollLeft -= (currX - origX);
		_v.cmeGliderInst.scrollItem(_v.cmeGliderInst.slide - 1); // Decrement slide
	}
	_f.closeShare(); // Close open share layer on carousel swipe
	slideContainer.removeEventListener('touchmove', handleTouchMove); // Unbind touchmove after initial event done
	slideContainer.removeEventListener('mousemove', handleTouchMove);
	setTimeout(function() {_v.cmeGliderSwiping = false;}, 250); // Allow short delay before unsetting 'currently swiping' flag
	wmdPageLink('fy-cmecont_arrow');
}

function handleTouchStart(e) { // Handle initial touch or click on carousel
	// Save cursor position for first touch
	if (e.type == 'touchstart') {
		origX = e.touches[0].pageX;
		origY = e.touches[0].pageY;		
	} else if  (e.type == 'mousedown') {
		origX = e.pageX;
		origY = e.pageY;
	}
	// Slight delay to allow for more pixel movement before reading touchmove event
	clearTimeout(touchDebounce);
	touchDebounce = setTimeout(function() {
		if (_v.isTouchDevice) {
			slideContainer.addEventListener('touchmove', handleTouchMove);
		} else {
			slideContainer.addEventListener('mousemove', handleTouchMove);
		}
	}, 35);
	// Bind touchend function to unbind listeners at end of swipe sequence
	if (_v.isTouchDevice) {
		slideContainer.addEventListener('touchend', handleTouchEnd);
	} else {
		slideContainer.addEventListener('mouseup', handleTouchEnd);
	}
}
/* / Custom Swiping */

function cmeGliderApiUrl() {	
	let queryParams= 'page=1&limit=30';
	if (typeof userHpId != 'undefined' && userHpId != '' && !isNaN(Number(userHpId))) {
		queryParams = queryParams+'&homePageId=' + userHpId;
	}
	if (_v.topContId || _v.topArticleId) {
		queryParams = (_v.topContId ? 'aspen_feed_nid=' + _v.topContId: 'article_id='+_v.topArticleId)+'&'+queryParams;
	}
	return _v.contentFeedURL+queryParams+'&include=cme&pvid=' + s_pageview_id;
}

function initCmeGlider() {
	
    slideContainer = document.querySelector('.cme-glider-slide-container');
    let gliderPrev = document.querySelector('.cme-glider .glider-prev');
    let gliderNext = document.querySelector('.cme-glider .glider-next');
    let gliderDots = document.querySelector('.cme-glider .dots');

    _v.cmeGliderInst = new Glider(slideContainer, {
        slidesToShow: 'auto',
		exactWidth: true,
        slidesToScroll: 1,
		itemWidth: 330,
        dots: gliderDots,
        draggable: false,
		duration: 2,
        scrollLock: false,
        arrows: {
            prev: gliderPrev,
            next: gliderNext
        },
        responsive: [
            {
                breakpoint: 768,
                settings: {
					itemWidth: undefined,
					exactWidth: false,
                    slidesToShow: 3.15,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 1024,
                settings: {
					itemWidth: undefined,
					exactWidth: false,
                    slidesToShow: 2.75,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 1280,
                settings: {
					itemWidth: undefined,
					exactWidth: false,
                    slidesToShow: 3.15,
                    slidesToScroll: 3
                }
            }
        ]
    });
	
	window.cmeGliderInst = _v.cmeGliderInst;
}

function addGhostCards(data) {
    let responseLength = data;

    if ((responseLength % 3) != 0) {
        responseLength = responseLength + 1;
        document.querySelector('.cme-glider-slide-container').appendChild(_u.strToDom(_t.cmeGliderGhostItem()));
        addGhostCards(responseLength);
    }
}

function fetchCmeData() {	
    return new Promise(function (resolve, reject) {
        _u.apiGet(cmeGliderApiUrl(),true).then(json => {			
			gliderJson = json;
			ajaxDone = true;
			resolve();
        }).catch((error) => {
			ajaxDone = true;
            resolve();
        });
    });
}

function handleCmeAjax() {
	if (_v.feedAndTopLoaded && ajaxDone && !ajaxAndFeedDone) {
		ajaxAndFeedDone = true;
		appendCmeGlider();
	}
}

function buildCardObject(cardData, index) {
	try {
		let result = cardData;
		Object.keys(_.pickBy(result, _.isNull)).forEach(function (key) {
			result[key] = '';
		});		
		if(result.publicationName === null || result.publicationName === 'null') {
			result.publicationName = '';
		}
		result.publicationName = result.publicationName.replace("Medscape Education", "").trim();
		
		result.publicationDate = _u.timeParse(result.publicationDate);

		// Ensure URI is environment-specific
		if (typeof result.uri != 'undefined' && result.uri != null) {
			result.uri = result.uri.replace(/((https?:)?\/\/)([^\.]+)(.+)?\.(medscape\.)([^\/]+)/, '$1$3.' + _u.getDomain() + '$5$6');
			if(_v.isFYE != null){
				result.uri = result.uri + '?src=FYE';
			}
		}

		if (result.imageUrl === '' || result.imageUrl === null) {
			result.imageUrl = 'https://img.' + _u.getDomain() + 'medscapestatic.com/pi/features/mymedscape/icons/image-education-fpo.jpg';
		}

		result.creditType = _f.getCmeCreditTypeValue(result.cmeCreditType).creditType;
		result.credits = _f.getCmeCreditTypeValue(result.cmeCreditType).credits;
		result.creditvalue = _f.getCmeCreditTypeValue(result.cmeCreditType).creditvalue;
		
		result.credits != undefined && Number(result.creditvalue) > 0 ?
		result.creditLabel = 'ACCREDITED' : result.creditLabel = 'EDUCATION';
		
		result.trackingValue = 'fy-contcme_' + + (index + 1);

		return result;
	} catch (e) {
		console.log(e);
	}
}

function appendCmeGlider() {
	let filteredValue = [];

	if (gliderJson != null) {
		// Check Dedupe Top Article from Carousel
		gliderJson.data.forEach(cardData => {
			if ((_v.topArticleId != null && String(cardData.contentId) != String(_v.topArticleId)) || (_v.topContId != null && String(cardData.aspenNid) != String(_v.topContId)) || (_v.topContId == null && _v.topArticleId == null)) {
				filteredValue.push(cardData);
			}
		});
	}

	let gliderJsonLength = gliderJson != null ? filteredValue.length : 0;

	// when we have 1 card
	if (gliderJsonLength == 1) {
		filteredValue.forEach((cardData, index) => {
			let data = buildCardObject(cardData, index);
							
			data.credits != undefined && Number(data.creditvalue) > 0 ?
			data.cmeTagName = 'Accredited Education' : data.cmeTagName = 'Education';

			_u.insertAfter(_u.strToDom(_feedt.cmeFeedItem(data)), document.querySelectorAll('.feed-container .pers-feed-item')[(_v.cmeCarouselPos - 1)])
		});

		document.dispatchEvent(new CustomEvent('cmeGliderLoaded'));
	} else if ((gliderJsonLength == 3 || gliderJsonLength == 2) && breakpoint != 1) {// when we have 2 or 3 card
		let feedCardAmt = document.querySelectorAll('.pers-feed-item').length;
		if (feedCardAmt >= _v.cmeCarouselPos) {
			_u.insertAfter(_u.strToDom(_t.cmeGenericTemplate()), document.querySelectorAll('.feed-container .pers-feed-item')[(_v.cmeCarouselPos - 1)])
		} else if (feedCardAmt > 0) {
			_u.insertAfter(_u.strToDom(_t.cmeGenericTemplate()), document.querySelectorAll('.feed-container .pers-feed-item')[(feedCardAmt - 1)])
		} else {
			document.querySelector('.feed-container').appendChild(_u.strToDom(_t.cmeGenericTemplate()));
		}

		filteredValue.forEach((cardData, index) => {
			let data = buildCardObject(cardData, index);

			document.querySelector('.cme-glider').appendChild(_u.strToDom(_t.cmeGliderItem(data)));
		});

		if (gliderJsonLength == 2) {
			document.querySelectorAll('.cme-card-container').forEach(element => {
				element.classList.add('double-cards');
			});
		}

		if (_u.qS('.cme-card-container') != null) {
			_u.qS('.cme-glider-container').classList.add('active');
		}

		document.dispatchEvent(new CustomEvent('cmeGliderLoaded'));
	} else if (((gliderJsonLength == 3 || gliderJsonLength == 2) && breakpoint == 1) || gliderJsonLength > 3) {// when we have more than 3 card
		let feedCardAmt = document.querySelectorAll('.pers-feed-item').length;
		if (feedCardAmt >= _v.cmeCarouselPos) {
			_u.insertAfter(_u.strToDom(_t.cmeGliderContainerTemplate()), document.querySelectorAll('.feed-container .pers-feed-item')[(_v.cmeCarouselPos - 1)])
		} else if (feedCardAmt > 0) {
			_u.insertAfter(_u.strToDom(_t.cmeGliderContainerTemplate()), document.querySelectorAll('.feed-container .pers-feed-item')[(feedCardAmt - 1)])
		} else {
			document.querySelector('.feed-container').appendChild(_u.strToDom(_t.cmeGliderContainerTemplate()));
		}

		filteredValue.forEach((cardData, index) => {
			let data = buildCardObject(cardData, index);
			
			if(document.querySelector('.cme-glider-slide-container') != null){
				document.querySelector('.cme-glider-slide-container').appendChild(_u.strToDom(_t.cmeGliderItem(data)));
			}			
		});
		
		let cmeCardAmt = document.querySelectorAll('.cme-card-container').length;

		// temporarly commenting it out
		// if (window.breakpoint != 1) {
		// 	addGhostCards(cmeCardAmt);
		// }
		
		if (cmeCardAmt <= 3 && _u.qS('.cme-glider-container') != null) {
			_u.qS('.cme-glider-container').classList.add('no-arrow');
		}
		
		if (cmeCardAmt == 1 && _u.qS('.cme-glider-container')!=null) {
			_u.qS('.cme-glider-container').classList.add('single');
		}

		if (_u.qS('.cme-card-container') != null && _u.qS('.cme-glider-container') != null) {
			_u.qS('.cme-glider-container').classList.add('active');
			initCmeGlider();
			if (_v.isTouchDevice) {
				slideContainer.removeEventListener('touchstart', handleTouchStart);
				slideContainer.addEventListener('touchstart', handleTouchStart);
			} else{
				slideContainer.removeEventListener('mousedown', handleTouchStart);
				slideContainer.addEventListener('mousedown', handleTouchStart);
			}
		}
		document.dispatchEvent(new CustomEvent('cmeGliderLoaded'));
	} else {
		document.dispatchEvent(new CustomEvent('cmeGliderLoaded'));
	}
}

function getCmeGlider() {	
	if (typeof window.hideCmeGlider == 'undefined' || !window.hideCmeGlider) {
		fetchCmeData().then(handleCmeAjax);
		document.addEventListener('feedAndTopLoaded', handleCmeAjax);
	}	
}

export default getCmeGlider;